module.exports = __webpack_public_path__ + "static/writing-book-6d0e02486b99b7a955cdcadfc19de465.png";